module.exports = "<div class=\"footer text-center\">\n  <span>Creado con\n    <i class=\"fa fa-heart\"></i> por Zooft Company Inc.</span>\n</div>"